// SUBMITTING VOUCHER CODE
export const SUBMIT_VOUCHER = "SUBMIT_VOUCHER";
export const SUBMIT_VOUCHER_ERROR = "SUBMIT_VOUCHER_ERROR";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
